<script lang="ts">
	interface Props {
		errorMessage: string
		errorCode: number
	}

	let { errorMessage, errorCode }: Props = $props()
</script>

<h3 class="upload-header">Error while Processing</h3>

<p>{errorMessage} [Error Code: {errorCode}]</p>

<style>
	p {
		color: var(--color-error);
	}
</style>
